import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';
import { newValueStyles, oldValueStyles } from 'app/shared/styles/valueDiff.styles';
import PropTypes from 'prop-types';

import { getCicDisplayValue } from 'utils/cicReason';

import { arrowStyles, valueChangeStyles } from './CicValueChange.styles';

const CicValueChange = ({ oldDisplay = null, newDisplay = null }) => (
  <Box sx={valueChangeStyles}>
    <Typography sx={oldValueStyles} variant="regular14">
      {getCicDisplayValue(oldDisplay)}
    </Typography>
    <Typography sx={arrowStyles} variant="regular14">
      →
    </Typography>
    <Typography sx={newValueStyles} variant="regular14">
      {getCicDisplayValue(newDisplay)}
    </Typography>
  </Box>
);

CicValueChange.propTypes = {
  newDisplay: PropTypes.string,
  oldDisplay: PropTypes.string,
};

export default memo(CicValueChange);
